import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import unwrapAxiosPromise from '../../../util/unwrapAxiosPromise';
import Organograma from '../../../components/organograma';
import { useSelector } from "react-redux";
import { acessoSelector } from '../../../store/acessos';
import AuthenticatedLayout from '../../../layouts/authenticated';
import AcessoMenu from '../../../components/acesso-menu';
import PesquisaMenu from '../../../components/pesquisa-menu';
import { isClienteGestorSelector } from '../../../store/autenticacao';
import SocietarioMenu from "../../../components/societario-menu";
import useTitle from "../../../hooks/useTitle";

export default function OrganogramaPage() {
  const { t } = useTranslation();
  const isClienteGestor = useSelector(isClienteGestorSelector);
  const acesso = useSelector(acessoSelector)
  const title = useTitle();
  const [loading, setLoading] = useState(false);
  const [organograma, setOrganograma] = useState([]);
  const acessoId = acesso?.id;

  const fetch = useCallback(() => {
    if (acessoId) {
      setLoading(true);
      unwrapAxiosPromise(axios.get('/societario/organograma', { params: { acessoId } }))
        .then(data => {
          setOrganograma(data.organograma);
          document.title = title + ' - ' + t('Organograma') + ' - ' + data.nome;
        })
        .finally(() => setLoading(false));
    } else {
      setOrganograma([]);
    }
  }, [title, acessoId]);


  useEffect(() => {
    fetch();
  }, [fetch, acessoId]);

  return (
    <AuthenticatedLayout
      menu={
        <>
          <AcessoMenu allowClear defaultRoute="/societario/organograma" modulo="societario"/>
          {acessoId > 0 && <PesquisaMenu/>}
          <SocietarioMenu showCreate={isClienteGestor}/>
        </>
      }
      contentStyle={{ maxWidth: 'unset', padding: 0 }}
    >
      <Organograma loading={loading} organograma={organograma} onUnload={fetch} defaultLayout="curved"/>
    </AuthenticatedLayout>);
}
